<template>
  <v-dialog    
    v-model="modal.show"
    width="1200"
    persistent 
    @keydown.esc="closeModal"
  > 
    <v-card class="mb-0" v-if="document">
      <v-card-title class="app-card-title">
        {{ document.document_type.name }}
        <v-spacer />
        <v-btn
          outlined
          small
          :disabled="!hasPrev"
          @click="navigate(-1)"
        >
          <v-icon left>chevron_left</v-icon>
          Anterior
        </v-btn>
        <v-btn
          class="ml-2"
          outlined
          small
          :disabled="!hasNext"
          @click="navigate(1)"
        >
          Próximo
          <v-icon right>chevron_right</v-icon>
        </v-btn>                        
      </v-card-title>
      <v-card-text class="app-card-content">
        <v-row>
          <v-col :lg="8" :md="8" :sm="8">
            <OrderDocumentApprovalButtons 
              :order="order"
              :document="document"
              @updated="fetchDocument()"
            />

            <v-img
              v-if="document.imageable"
              lazy-src="https://picsum.photos/id/11/10/6"                
              max-height="350"
              :src="document.content.url"
            />
            <iframe
              v-else
              :src="document.content.url"
              frameborder="0" 
              style="width: 100%; height: 500px;"
            />
          </v-col>

          <v-col :lg="4" :md="4" :sm="4">
            <h4 class="mb-2">Detalhes do Documento</h4>
            <strong>Nome: </strong> {{ document.document_type.name }} <br>
            <strong>Filename: </strong> {{ document.content.filename }} <br>
            <strong>Tipo: </strong> {{ document.content.content_type }} <br>
            <template v-if="document.reason">
              <strong>Motivo Recusa: </strong> {{ document.reason }} <br>
            </template>
            <strong>Status: </strong> 
            <v-chip
              class="ma-2" 
              small               
              :color="documentStatusColor(document.status.raw)"                
            >
              {{ document.status.label }}
            </v-chip>
            <br>
            <strong>Enviado em: </strong> {{ document.uploaded_at.formatted }} <br>

            <v-divider class="mt-3 mb-3" />

            <div v-if="document.imageable">
              <h4 class="mb-2">Metadados do Documento</h4>
              <strong>Latitude: </strong> {{ document.metadata && document.metadata.latitude ? document.metadata.latitude  : '-'}} <br>
              <strong>Longitude: </strong> {{ document.metadata && document.metadata.longitude ? document.metadata.longitude : '-'}} <br>
              <strong>Dispositivo: </strong> {{ document.metadata && document.metadata.camera ? document.metadata.camera : '-' }} <br>
              <strong>Data de criação original: </strong> {{ document.metadata && document.metadata.created_at ? document.metadata.created_at.formatted : '-' }} <br>
              <v-divider class="mt-3 mb-3" />
            </div>
                        
            <OrderDocumentInfoComplementary 
              v-if="document.fieldable"
              :document="document"
              :disabled="!canEditDocumentFields()"
            />
          </v-col>
        </v-row>          
      </v-card-text>
      <v-divider />
      <v-card-actions>        
        <v-spacer />
        <v-btn
          outlined
          color="error"
          @click="closeModal"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>    
  </v-dialog>  
</template>

<script> 
  import { documentStatusColor } from '@/util/document-status-color';
  import DocumentService from '@/services/documento.service';
  import OrderDocumentApprovalButtons from './OrderDocumentApprovalButtons.vue';  
  import OrderDocumentInfoComplementary from './OrderDocumentInfoComplementary.vue';

  export default {
    name: 'OrderDocumentInfoModal',
    
    components: {
      OrderDocumentApprovalButtons,
      OrderDocumentInfoComplementary
    },

    props: {
      order: {
        type: Object,
        required: true
      },
      
      documentId: {
        type: Number,
        required: true
      },

      documentIds: {
        type: Array,
        default: () => [],
      },

      documentIndex: {
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        modal: { show: true },
        document: null,
        activeIndex: this.documentIndex,
      };
    },

    computed: {
      activeDocumentId() {
        return this.documentIds.length > 0 ? this.documentIds[this.activeIndex] : this.documentId;
      },

      hasPrev() {
        return this.activeIndex > 0;
      },

      hasNext() {
        return this.activeIndex < this.documentIds.length - 1;
      },
    },

    mounted() {
      this.fetchDocument();
    },

    methods: {
      closeModal() {
        this.$emit('close');
      },

      openModal() {
        this.modal.show = true;
      },

      documentStatusColor(status) {
        return documentStatusColor(status);
      },

      navigate(direction) {
        this.activeIndex += direction;
        this.document = null;
        this.fetchDocument();
      },

      fetchDocument() {
        DocumentService
          .show(this.activeDocumentId)
          .subscribe((response) => {
            this.document = response;
          });
      },

      canEditDocumentFields() {
        return this.order && this.order.status.raw === 'under_analysis' 
          && this.document.status.raw === 'unverified' && this.document.content.url; 
      }
    },
  }
</script>